import {
  DietitianClinicBillingProfileResource,
  dietitianClinicBillingProfileResourceSchema,
} from "@client/resources/DietitianClinicBillingProfileResource";
import { APIMethods, ApiResponse } from "@typeDefinitions";
import { fetchData } from "@utils/api";
import { logFetchValidateError } from "@utils/validate";
import { object } from "yup";

export type FetchBillingProfileResponse =
  ApiResponse<DietitianClinicBillingProfileResource | null>;

const schema = object({
  data: dietitianClinicBillingProfileResourceSchema.nullable().default(null),
});

export const fetchBillingProfile =
  async (): Promise<FetchBillingProfileResponse> => {
    const response = await fetchData(
      "/dietitian/clinic/billing-profile",
      APIMethods.GET,
    );

    return await schema
      .validate(response)
      .catch(logFetchValidateError("/dietitian/clinic/billing-profile"));
  };
